export const MAX_CHAR_PER_LINE = 38;

const isPunctuation = (ch: string): boolean => {
  const regex = /[!-/:-@[-`{-~\u2000-\u206F\u3000-\u303F\uff00-\uffef]/g;
  return regex.test(ch);
};

export function splitChars(sentence: string) {
  if (!sentence) return [];
  const words: string[] = [];
  let word = "";
  let cjkFlag = isCJK(sentence[0]);

  for (const character of sentence) {
    // if (character === '|') {
    //   if (word) {
    //     words.push(word);
    //     word = '';
    //   }
    //   words.push('<br />');
    //   cjkFlag = false;
    //   continue;
    // }
    if (character === " ") {
      // Space
      if (word) {
        words.push(word);
        word = "";
      }
      words.push(" ");
      cjkFlag = false;
    } else if (isCJK(character) && !isPunctuation(character)) {
      if (!cjkFlag && word) {
        words.push(word);
        word = "";
      }
      words.push(character);
      cjkFlag = true;
    } else {
      if (isPunctuation(character)) {
        if (word) {
          // If it is a punctuation and there is a preceding word, add it to the word
          word += character;
          words.push(word);
          word = "";
        } else if (words.length > 0) {
          // If no preceding word in the current iteration, but there are already words in the array, append to the last word
          words[words.length - 1] += character;
        } else {
          // If no preceding word, still add the punctuation as a new word
          words.push(character);
        }
        continue;
      }

      if (cjkFlag && word) {
        words.push(word);
        word = "";
      }
      word += character;
      cjkFlag = false;
    }
  }

  if (word) {
    words.push(word);
  }

  return words;
}

function isCJK(character: string) {
  return !!character.match(/[\u4e00-\u9fa5]|[\u0800-\u4e00]|[\uac00-\ud7ff]/);
}
